
if (!window.customElements.get('add-to-wishlist-data-layer-button')) {
    class AddToWishlistDataLayerButton extends HTMLElement {
        constructor() {
            super();
            this.submitButtonElement = this.querySelector('[data-add-to-wishlist-submit-button]');
            this.currentCustomerData = JSON.parse(document.querySelector('[data-wishlist-customer-info]').textContent);
            this.jsonData = JSON.parse(this.querySelector('[data-product-info-for-wishlist]').textContent);
            this.submitButtonElement.addEventListener('click',this.onSubmitButtonClick.bind(this));
        }

        isProductInWishlist(selectedProduct, selectedVariant){
            if (window.localStorage.getItem("th_wishlist_products_list")) {
                const wishlistItems = JSON.parse(window.localStorage.getItem("th_wishlist_products_list"));
                const wishlistSelectedItems = wishlistItems.filter((item) => {
                    return item.wishlisted
                        && item.shopify_product_id == selectedProduct.id
                        && item.shopify_variant_id == selectedVariant.id
                    ;
                });
                return wishlistSelectedItems.length > 0;
            }
            return false;
        }
        getSelectedProduct() {
            return this.jsonData.product;
        }
        getSelectedVariant() {
            const variantsDictionary = this.jsonData.variants;
            const selectedVariant = variantsDictionary.filter(variant => variant.id == this.submitButtonElement.dataset.variant_id);

            if (selectedVariant.length){
                return selectedVariant[0];
            }

            return {};
        }
        onSubmitButtonClick(event) {

            const selectedProduct = this.getSelectedProduct();
            const selectedVariant = this.getSelectedVariant();
            if (!this.isProductInWishlist(selectedProduct, selectedVariant)) {
                window.dataLayer = window.dataLayer || [];

                const payload = {
                    "event": "add_to_wishlist_stape",
                    "actual_url": window.location.href,
                    "ecomm_pagetype": this.getPageType(),
                    ...this.currentCustomerData,
                    "ecommerce": {
                        "value": selectedVariant?.price / 100,
                        "currency": this.currentCustomerData.currency,
                        "items": [{
                            "item_id": selectedProduct?.id,
                            "item_sku": selectedVariant?.sku,
                            "item_variant": selectedVariant?.id,
                            "item_name": selectedProduct?.title,
                            "variant_name": selectedVariant?.title,
                            "item_category": selectedProduct?.type,
                            "price": selectedVariant?.price / 100,
                            "item_brand": selectedProduct?.vendor,
                            "imageURL": selectedVariant?.featured_image ?? selectedProduct?.featured_image,
                            "item_url": selectedProduct?.url,
                            "quantity": "1"
                        }]
                    }
                }
                window.dataLayer.push(payload);
            }
        }

        getPageType() {

            let path = window.location?.pathname;
            
            if (path.includes('/collection')) { return 'category'; }
            else if (path.includes('/product')) { return 'product'; }
            else if (path.includes('/cart')) { return 'basket'; }
            else if (path === '/') { return 'home'; }
            else if (path.includes('thank_you') || path.includes('thank-you')) { return 'purchase'; }  
            else if (path.includes('/checkout')) { return 'basket'; }
            else { return 'other'; }

        }
    }
    customElements.define('add-to-wishlist-data-layer-button', AddToWishlistDataLayerButton);
}